import LinkNav from 'components/partials/links/components/link-nav/LinkNav';
import { getPageLink } from 'helpers/resources';

import DropdownWrapper from '../DropdownWrapper';

const GetEducatedNavGroup = () => {
  return (
    <DropdownWrapper>
      <LinkNav to={getPageLink('page-get-educated')} className="nav-link">
        Get Educated
      </LinkNav>
      <div className="dropdown-menu">
        <div className="dropdown-wrapper">
          <div className="links-title">
            <LinkNav to={getPageLink('page-get-educated')}>
              Get Educated
            </LinkNav>
            <p>
              MBA members have quick, easy access to a range of tools designed
              to help them make accurate financial decisions and develop solid
              financial plans.
            </p>
          </div>
          <div>
            <LinkNav
              to={getPageLink('page-get-educated')}
              className="dropdown-item"
              data-gtm-primary-nav-get-educated-link
            >
              Get Educated
            </LinkNav>
            <LinkNav
              to={getPageLink('page-financial-resources')}
              className="dropdown-item"
            >
              Financial Resources
            </LinkNav>
          </div>
        </div>
      </div>
    </DropdownWrapper>
  );
};

export default GetEducatedNavGroup;
